export const CONFIRMATION_MODAL = 'CONFIRMATION_MODAL';
export const ERROR_MODAL = 'ERROR_MODAL';
export const SUCCESS_MODAL = 'SUCCESS_MODAL';
